import { render, staticRenderFns } from "./SyncToast.vue?vue&type=template&id=218b2f48&scoped=true"
import script from "./SyncToast.vue?vue&type=script&lang=js"
export * from "./SyncToast.vue?vue&type=script&lang=js"
import style0 from "./SyncToast.vue?vue&type=style&index=0&id=218b2f48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218b2f48",
  null
  
)

export default component.exports